import type { AppStore } from "@/store/AppStore";
import type {
  GetAssistantFollowUpInput,
  GetAssistantFollowUpOutput,
} from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getAssistantFollowUpInputSchema,
  getAssistantFollowUpOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import { AiToolkitAssistantFollowUpNotFoundError } from "@/modules/ai-toolkit/errors";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import {
  buildAssistantFollowUpFromCreateChangeRequestUpdateValue,
  buildAssistantFollowUpFromSyncUpdateValue,
  isCreateFollowUpChangeRequestUpdateValue,
} from "@/modules/ai-toolkit/tools/assistant-follow-ups/assistant-follow-up-tools.helpers";

export const getAssistantFollowUp = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetAssistantFollowUpInput;
}): Promise<GetAssistantFollowUpOutput> => {
  const followUpRow = await store.assistantFollowUps.localTable.get(input.followUpId);

  if (followUpRow) {
    return {
      followUp: buildAssistantFollowUpFromSyncUpdateValue({ updateValue: followUpRow }),
    };
  }

  const changeRequestRow = await store.assistantFollowUpChangeRequests.localTable.get(
    input.followUpId
  );

  if (
    !changeRequestRow ||
    !isCreateFollowUpChangeRequestUpdateValue({ updateValue: changeRequestRow })
  ) {
    throw new AiToolkitAssistantFollowUpNotFoundError({ followUpId: input.followUpId });
  }

  return {
    followUp: buildAssistantFollowUpFromCreateChangeRequestUpdateValue({
      updateValue: changeRequestRow,
    }),
  };
};

export const getAssistantFollowUpTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetAssistantFollowUp,
  GetAssistantFollowUpInput,
  GetAssistantFollowUpOutput
> = {
  name: AiToolkitToolName.GetAssistantFollowUp,
  inputSchema: getAssistantFollowUpInputSchema,
  outputSchema: getAssistantFollowUpOutputSchema,
  strict: true,
  execute: getAssistantFollowUp,
};
